import { render, staticRenderFns } from "./OficinasCaetanoRetailLogoES.vue?vue&type=template&id=89bd145a&scoped=true&"
var script = {}
import style0 from "./OficinasCaetanoRetailLogoES.vue?vue&type=style&index=0&id=89bd145a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bd145a",
  null
  
)

export default component.exports